module.exports = __webpack_public_path__ + "static/media/image1.ffdd1410.png";